import React from 'react';
import { Typography } from '@material-ui/core';
import { InfoIconWithTtProps } from './types';
import CustomTooltip from '../../BuildingBlocks/Tooltip/Tooltip';
import makeStyles from '@material-ui/core/styles/makeStyles';
import InfoIcon from '@material-ui/icons/Info';

const useStyles = makeStyles((theme: any) => ({
  infoIcon: {
    color: 'rgba(0, 0, 0, 0.38)',
  },
}));

export default function InfoIconWithTooltip({ helpText }: InfoIconWithTtProps) {
  const classes = useStyles();
  return (
    <CustomTooltip
      arrow
      placement="top"
      title={<Typography>{helpText}</Typography>}
    >
      <InfoIcon className={classes.infoIcon} />
    </CustomTooltip>
  );
}
